import { Center, Text } from '@chakra-ui/react';
import { Drawer } from '@halo/ui-react';
import { CloseIcon } from '@halo/ui-chat-react';

export interface ChatPanelDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  children: React.ReactNode;
  title: string;
}

export const ChatPanelDrawer = memo(function ChatPanelDrawer({
  open,
  onOpenChange,
  children,
  title,
}: ChatPanelDrawerProps) {
  return (
    <Drawer.Root open={open} onOpenChange={(e) => onOpenChange(e.open)} lazyMount unmountOnExit>
      <Drawer.Positioner pos="absolute" boxSize="full">
        <Drawer.Content bg="bg.subtle" w="456px" flex="0 0 auto" maxW="none">
          <Drawer.Header justifyContent="space-between" py="2.5" px="4" pt="5">
            <Text fontSize="md" fontWeight="semibold">
              {title}
            </Text>
            <Drawer.CloseTrigger asChild pos="relative" right="0" top="0">
              <Center fontSize="md" cursor="pointer" color="fg.subtle">
                <CloseIcon />
              </Center>
            </Drawer.CloseTrigger>
          </Drawer.Header>
          <Drawer.Body className="scrollHover" px="4" py="2.5">
            {children}
          </Drawer.Body>
        </Drawer.Content>
      </Drawer.Positioner>
    </Drawer.Root>
  );
});
